// extracted by mini-css-extract-plugin
module.exports = {"bannerStyles":"MainContent_bannerStyles__2flUt","buttonGroup":"MainContent_buttonGroup__n6mPU","imageStyles":"MainContent_imageStyles__2uYe1"};